/* eslint-disable import/prefer-default-export */

/**
 * Get Video ID from URL
 *
 * @param url
 * @return {*}
 */
export const getVideoId = url => {
    if (!url) return null;

    // YouTube
    if (url.includes('youtube.com/watch?v=')) {
        return {type: 'youtube', id: url.split('?v=')[1]};
    }
    if (url.includes('youtube.com/embed/')) {
        return {type: 'youtube', id: url.split('embed/')[1]};
    }
    else if (url.includes('youtu.be/')) {
        return {type: 'youtube', id: url.split('youtu.be/')[1]};
    }

    // Vimeo - Extract numeric ID from various URL formats
    // Matches: vimeo.com/123456, vimeo.com/123456/, vimeo.com/123456?params, vimeo.com/channels/staff/123456, etc.
    const vimeoRegex = /https?:\/\/(www\.)?vimeo\.com\/(?:.*\/)?(\d+)(?:[?/].*)?$/;
    const vimeoUrl = url.match(vimeoRegex);
    if (vimeoUrl && vimeoUrl[2]) {
        return {type: 'vimeo', id: vimeoUrl[2]};
    }

    return null;
};



// WEBPACK FOOTER //
// ./frontend/helpers/video.js